import { Box, Text, Image, Button, Flex, Heading, List, ListItem, ListIcon } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import logo from "../assets/logo/logo_wobble.png";
import Reveal, { LiveBackground } from "./motion";
import WobbleShowcase from "./WobbleShowcase";
import { HomeContent } from "../data/homeContent";

type ProductDisplayProps = { wobble: HomeContent["wobble"] };

const ProductDisplay = ({ wobble }: ProductDisplayProps) => (
  <Box as="section" id="products" position="relative" bg="wobble.50" py={{ base: 20, md: 28 }} overflow="hidden">
    <LiveBackground variant="panel" tone="wobble" />
    <Flex
      position="relative"
      zIndex={1}
      maxW="1400px"
      mx="auto"
      px={{ base: 5, md: 8 }}
      direction={{ base: "column", lg: "row" }}
      align="center"
      gap={{ base: 12, lg: 20 }}
    >
      <Reveal flex="1">
        <Image w={130} src={logo} alt="Wobble logó" mb={5} />

        <Heading as="h2" fontFamily="heading" fontSize={{ base: "3xl", md: "4xl" }} mb={5}>
          <Text as="span" fontFamily="'Lato', sans-serif" fontWeight="800" color="wobble.600">
            Wobble
          </Text>
          {wobble.heading}
        </Heading>

        <Text color="slate.700" fontSize={{ base: "sm", md: "md" }} mb={6} lineHeight="1.8">
          {wobble.body}
        </Text>

        <List spacing={3} mb={6}>
          {wobble.bullets.map((b) => (
            <ListItem key={b} display="flex" alignItems="flex-start" fontSize="sm" color="ink.900">
              <ListIcon as={CheckCircleIcon} color="wobble.600" mt={1} />
              {b}
            </ListItem>
          ))}
        </List>

        <Text color="slate.500" fontSize="sm" mb={8}>
          {wobble.fit}
        </Text>

        <Button
          size="lg"
          bg="wobble.600"
          color="white"
          fontWeight="bold"
          as="a"
          href="https://wobble.hu"
          target="_blank"
          rel="noopener noreferrer"
          _hover={{ bg: "wobble.700", transform: "translateY(-2px)" }}
          transition="all 0.2s ease"
        >
          {wobble.cta}
        </Button>
      </Reveal>

      <Reveal flex="1.15" delay={0.15} w="100%">
        <WobbleShowcase />
      </Reveal>
    </Flex>
  </Box>
);

export default ProductDisplay;
